import {gsap} from "gsap";
import {FlightModeGameAssets} from "../FlightModeGameAssets";
import {FlightMode} from "../FlightMode";
import {SpineGSAPWrapper} from "../misc/SpineGSAPWrapper";
import {BLEND_MODES} from "pixi.js";
import imageLoaderAdapter = PIXI.spine.imageLoaderAdapter;

export class FlightModeSymbol extends PIXI.Container {
    public winAnimation:PIXI.spine.Spine;
    public mainSprite:PIXI.Sprite;
    public symbolName:string;
    public multiplierText:PIXI.BitmapText;
    public multiplier:number;
    public winGlow:PIXI.Sprite;
    public shakeTimeline:gsap.core.Timeline;

    public unlocked:boolean = false;
    public unlockedSprite?:PIXI.Sprite;
    public emptySprite?:PIXI.Sprite;
    public maxWinIdle?:PIXI.spine.Spine;
    public maxWinIdleTl?:gsap.core.Timeline;

    public xHoleSpine?:PIXI.spine.Spine;
    public multiplierSpine?:PIXI.spine.Spine;
    public scatterSpine?:PIXI.spine.Spine;
    public alreadyExploded:boolean = false;

    constructor(name:string, multiplier:number = 1) {
        super();
        this.symbolName = name;
        this.multiplier = multiplier;

        this.mainSprite = new PIXI.Sprite(FlightMode.assetLoader.getTextures(FlightModeGameAssets.getSymbolStateTexturePath(this.symbolName))[0]);
        this.mainSprite.anchor.set(0.5,0.5);
        this.addChild(this.mainSprite);

        if (this.symbolName == "MAX") {
            this.zIndex = 500;
            this.removeChild(this.mainSprite);
            this.mainSprite = new PIXI.Sprite(FlightMode.assetLoader.getTextures("MAX/MAX_Blocked")[0]);
            this.mainSprite.anchor.set(0.5, 0.5);
            this.addChild(this.mainSprite);
        }

        if (this.multiplier > 1) {
            this.setMultiplier(this.multiplier);
        }

        if (this.symbolName == "MAX") {
            this.unlockedSprite= new PIXI.Sprite(FlightMode.assetLoader.getTextures("MAX/MAX")[0]);
            this.unlockedSprite.anchor.set(0.5, 0.5);
            this.unlockedSprite.alpha = 0;
            this.addChildAt(this.unlockedSprite, 0);
            this.emptySprite = new PIXI.Sprite(FlightMode.assetLoader.getTextures("MAX/MAX_Empty")[0]);
            this.emptySprite.anchor.set(0.5, 0.5);
            this.emptySprite.alpha = 0;
            this.addChildAt(this.emptySprite, 0);
            this.maxWinIdle =
                new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.MAX_SYMBOL));
            this.maxWinIdle.alpha = 0;
            this.addChild(this.maxWinIdle);
        }
    }

    public setMultiplier(newValue:number) {
        if (this.symbolName != "MAX" && this.symbolName != "MI" && this.symbolName != "S") {
            this.multiplier = newValue;
            if (this.multiplierText == undefined) {
                this.multiplierText = new PIXI.BitmapText(`${this.multiplier}X`, {
                    fontName : FlightModeGameAssets.MULTIPLIER_FONT,
                    fontSize : 35,
                });
                (<PIXI.Point>this.multiplierText.anchor).set(1, 1);
                this.multiplierText.position.set(48, 62);
                this.addChild(this.multiplierText);
            } else {
                this.multiplierText.text = `${this.multiplier}X`;
            }
            if (this.multiplierText.width > 100)
                this.multiplierText.scale.x = 100 / this.multiplierText.width;
        }
    }

    public getWinAnimation(winRatio:number = 0.5):gsap.core.Timeline {
        if (this.winGlow != undefined && this.symbolName != "W")
            return gsap.timeline();

        const alreadyBlinked = this.winGlow != undefined;

        if (!alreadyBlinked) {
            const symbolName = this.symbolName.startsWith("M") ? "M_All" : this.symbolName
            this.winGlow = new PIXI.Sprite(FlightMode.assetLoader.getTextures(`SYM_Blink/Blink_${symbolName}`)[0]);
            this.winGlow.anchor.set(0.5, 0.5);
            this.winGlow.alpha = 0;
            this.winGlow.blendMode = BLEND_MODES.ADD;
            this.addChild(this.winGlow);
        }

        return gsap.timeline()
            .add(() => {
                this.winGlow.alpha = 1;
                this.mainSprite.tint = 0xffffff;
                if (this.multiplierText != undefined)
                    this.multiplierText.tint = 0xffffff;
            })
            .add(gsap.to(this.winGlow, {duration: 0.08, alpha: 0}), '>0.08')
            .add(() => {
                if (!alreadyBlinked)
                    this.startShaking(winRatio);
            })
    }

    public setNoWin():gsap.core.Timeline {
        const bruh = {color:255};
        return gsap.timeline({onUpdate: () => {
                const color = Math.ceil(bruh.color);
                this.mainSprite.tint = (color << 16) + (color << 8) + color;
                if (this.multiplierText != undefined)
                    this.multiplierText.tint = (color << 16) + (color << 8) + color;
            }})
            .add(gsap.to(bruh, {color: 127, duration: 0.1}));
    }

    public setNormal():gsap.core.Timeline {
        const bruh = {color:127};
        return gsap.timeline({onUpdate: () => {
                const color = Math.ceil(bruh.color);
                if (this.mainSprite.tint != 0xffffff) {
                    this.mainSprite.tint = (color << 16) + (color << 8) + color;
                    if (this.multiplierText != undefined)
                        this.multiplierText.tint = (color << 16) + (color << 8) + color;
                }
            }})
            .add(gsap.to(bruh, {color: 255, duration: 0.1}));
    }

    public startShaking(winRatio:number = 0.5) {
        const shakeSize = winRatio < 15 ? 1 : 3;
        const startX = this.position.x;
        const startY = this.position.y;
        this.shakeTimeline = gsap.timeline();
        this.shakeTimeline.repeat(-1);
        this.shakeTimeline.add(() => {
            const newX = startX + Math.round(Math.random() * shakeSize - shakeSize * 2);
            const newY = startY + Math.round(Math.random() * shakeSize - shakeSize * 2);
            this.position.set(newX, newY);
        })
        this.shakeTimeline.add(() => {
            this.position.set(startX, startY);
        }, '>0.025');
    }

    public stopShaking() {
        if (this.shakeTimeline != undefined)
            this.shakeTimeline.repeat(0);
    }

    public startBombFuse() {
        const fuseSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.BOMB_FUSE));
        fuseSpine.alpha = 0;
        this.addChild(fuseSpine);

        return gsap.timeline()
            .add(() => {
                fuseSpine.alpha = 1;
                FlightMode.soundPlayer.playLoopingSound("bombFuse");
            })
            .add(SpineGSAPWrapper.createTimeline(fuseSpine, 0, "B_Attention"))
            .add(() => {
                FlightMode.soundPlayer.stopSound("bombFuse");
                this.removeChild(fuseSpine);
            })
    }

    public explode(winRatio:number = 0.5) {
        if (this.alreadyExploded)
            return gsap.timeline();

        const spineName = winRatio < 0 ? FlightModeGameAssets.EXPLOSIONS_BOMB :
                          winRatio < 1 ? FlightModeGameAssets.EXPLOSIONS_LOW :
                          winRatio < 15 ? FlightModeGameAssets.EXPLOSIONS_MID :
                          FlightModeGameAssets.EXPLOSIONS_HIGH;
        const explosionSpine = new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(spineName));
        this.alreadyExploded = true;

        return gsap.timeline()
            .add(() => {
                if (this.multiplierSpine != undefined)
                    this.removeChild(this.multiplierSpine);
                this.stopShaking();
                this.removeChild(this.mainSprite);
                this.removeChild(this.multiplierText);
                this.addChild(explosionSpine);
            })
            .add(SpineGSAPWrapper.createTimeline(explosionSpine, 0, `${this.symbolName}_Xplod`))
            .add(() => {
                this.removeChild(explosionSpine);
            })
    }

    public landAnimation() {
        const landingSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.LANDING_SPINE));

        if (landingSpine.state.hasAnimation(`${this.symbolName}_Landing`))
            return gsap.timeline()
                .add(() => {
                    this.addChildAt(landingSpine, 0);
                    this.removeChild(this.mainSprite);
                })
                .add(SpineGSAPWrapper.createTimeline(landingSpine, 0, `${this.symbolName}_Landing`))
                .add(() => {
                    this.addChildAt(this.mainSprite, 0);
                    this.removeChild(landingSpine);
                })

        return gsap.timeline();
    }

    public unlockMaxWin() {
        if (this.unlocked)
            return gsap.timeline();

        const explosionSpine =new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.EXPLOSIONS_BOMB));
        explosionSpine.alpha = 0;
        this.addChild(explosionSpine);

        const maxWinIdleLoopTl = gsap.timeline()
            .add(() => {
                if (this.emptySprite?.alpha == 1 || !this.unlocked)
                    maxWinIdleLoopTl.kill();
                else
                    this.maxWinIdle!.state.setAnimation(0, "MAX_Idle", false);
            }, 6 + (FlightMode.seedableRandom.nextNumber() * 2 - 1));
        maxWinIdleLoopTl.repeat(-1);

        return gsap.timeline()
                .add(() => {
                    this.mainSprite.alpha = 0;
                    explosionSpine.alpha = 1;
                    this.unlockedSprite!.alpha = 1;
                    this.maxWinIdle!.alpha = 1;
                    FlightMode.soundPlayer.playSound("maxWinSymGlass");
                })
                .add(SpineGSAPWrapper.createTimeline(explosionSpine, 0, "MAX_Blocked_Xplod"))
                .add(() => {
                    this.removeChild(explosionSpine);
                    this.maxWinIdleTl = maxWinIdleLoopTl;
                    this.unlocked = true;
                })
    }

    public lockMaxWin() {
        const winGlow = new PIXI.Sprite(FlightMode.assetLoader.getTextures("SYM_Blink/Blink_Max")[0]);
        winGlow.anchor.set(0.5, 0.5);
        winGlow.alpha = 0;
        winGlow.blendMode = BLEND_MODES.ADD;
        this.addChild(winGlow);

        return gsap.timeline()
            .add(() => {
                winGlow.alpha = 1;
                this.unlockedSprite!.alpha = 0;
                this.emptySprite!.alpha = 0;
                this.maxWinIdle!.alpha = 0;
                this.mainSprite.alpha = 1;
                this.unlocked = false;
                this.alreadyExploded = false;
                this.maxWinIdleTl?.kill();
                this.maxWinIdle!.state.setEmptyAnimation(0, 0);
            })
            .add(gsap.to(winGlow, {duration: 0.08, alpha: 0}), '>0.08')
            .add(() => {
                this.removeChild(winGlow);
            })
    }

    public winMaxWin() {
        return gsap.timeline()
            .add(() => {
                this.maxWinIdle!.state.setEmptyAnimation(0,0);
                this.maxWinIdleTl?.kill()
                this.unlockedSprite!.alpha = 0;
                this.emptySprite!.alpha = 1;
            })
            .add(SpineGSAPWrapper.createTimeline(this.maxWinIdle!, 0, "MAX_Activ8"))
            .add(() => {
                this.maxWinIdle!.state.setEmptyAnimation(0,0);
            })
    }

    public bumpSymbol() {
        return gsap.timeline()
            .add(gsap.to(this.scale, {duration:0.15, x: 1.2, y: 1.2}))
            .add(gsap.to(this.scale, {duration:0.15, x: 1, y: 1}))
    }

    public shrinkAndDisappear() {
        return gsap.timeline()
            .add(gsap.to(this.scale, {duration:0.4, x: 0, y: 0, ease:"power4.out"}))
            .add(gsap.to(this, {duration:0.4, alpha: 0, ease:"power4.out"}), '<')
    }

    public growAndAppear() {
        const xHoleWet =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.XHOLE_WET))
        xHoleWet.alpha = 0;
        this.addChild(xHoleWet);

        return gsap.timeline()
            .add(gsap.to(this.scale, {duration:0.2, x: 1, y: 1, ease:"power4.out"}))
            .add(gsap.to(this, {duration:0.2, alpha: 1, ease:"power4.out"}), '<')
            .add(() => {
                xHoleWet.alpha = 1;
            })
            .add(SpineGSAPWrapper.createTimeline(xHoleWet, 0, "Wet"))
            .add(() => {
                this.removeChild(xHoleWet);
            })
    }

    public turnIntoWild() {
        const wildSprite = new PIXI.Sprite(FlightMode.assetLoader.getTextures("W/W")[0]);
        wildSprite.anchor.set(0.5, 0.5);
        wildSprite.alpha = 0;
        this.addChildAt(wildSprite, 1);

        return gsap.timeline()
            .add(() => {
                this.mainSprite.alpha = 0;
                FlightMode.soundPlayer.playSound("xHoleConvertToWild");
            })
            .add(SpineGSAPWrapper.createTimeline(this.xHoleSpine!, 0, "XH_To_Wild"))
            .add(() => {
                this.symbolName = "W";
                this.removeChild(this.mainSprite);
                this.removeChild(this.xHoleSpine!);
                this.mainSprite = wildSprite;
                wildSprite.alpha = 1;
            })
    }

    public activateXHole() {
        this.xHoleSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.XHOLE_SPINE));
        this.xHoleSpine.alpha = 0;
        this.addChild(this.xHoleSpine);

        return gsap.timeline()
            .add(() => {
                this.xHoleSpine!.alpha = 1;
                FlightMode.soundPlayer.playSound("xHoleOpenSwirl");
            })
            .add(SpineGSAPWrapper.createTimeline(this.xHoleSpine, 0, "Activ8"))
            .add(() => {
                FlightMode.soundPlayer.playSound("xHoleClose");
            }, 0.8)
    }

    public xHoleOpenToilet() {
        return gsap.timeline()
            .add(SpineGSAPWrapper.createTimeline(this.xHoleSpine!, 0, "Open"))
            .add(() => {
                FlightMode.soundPlayer.playSound("xHoleLidOpen");
            }, '<')
    }

    public xHoleSpit() {
        return gsap.timeline()
            .add(SpineGSAPWrapper.createTimeline(this.xHoleSpine!, 0, "XH_Spit"))
    }

    public multiplierSymbolReveal(multiplier:number) {
        this.multiplierSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.MULTIPLIER_SYMBOL));
        this.multiplierSpine.alpha = 0;
        this.addChild(this.multiplierSpine);

        return gsap.timeline()
            .add(() => {
                this.multiplierSpine!.alpha = 1;
                FlightMode.soundPlayer.playSound("multiplierIncreaserFlip")
            })
            .add(SpineGSAPWrapper.createTimeline(this.multiplierSpine, 0, `${multiplier}x`))
            .add(() => {
                this.multiplierSpine!.state.setAnimation(0, `${multiplier}x_Idle`, false);
            })
    }

    public goldenMultiplierReveal() {
        const multiplierSpine =
            new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.GOLDEN_MULTIPLIER));

        return gsap.timeline()
            .add(() => {
                this.addChild(multiplierSpine);
                FlightMode.soundPlayer.playSound("multiplierIncreaserGoldenActivate");
            })
            .add(SpineGSAPWrapper.createTimeline(multiplierSpine, 0, "GM"))
            .add(() => {
                this.removeChild(multiplierSpine);
            })
    }

    public scatterWinStart() {
        if (this.scatterSpine == undefined) {
            this.scatterSpine =
                new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.SCATTER_SPINE));
            this.scatterSpine.alpha = 0;
            this.addChild(this.scatterSpine);
        }

        return gsap.timeline()
            .add(() => {
                this.scatterSpine!.alpha = 1;
                this.scatterSpine!.state.setAnimation(0, "S_Win", true);
            })
    }

    public scatterWinStop() {
        return gsap.timeline()
            .add(() => {
                this.scatterSpine!.alpha = 0;
                this.scatterSpine!.state.setEmptyAnimation(0, 0);
            })
    }
}